import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { IStore } from '@rbi-ctg/store';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';
import { useInRestaurantRedemptionContext } from 'state/loyalty/in-restaurant-redemption';
import { ServiceMode } from 'state/service-mode';
import { useStoreContext } from 'state/store';
import { StoreProxy } from 'state/store/hooks';

import { LIST } from '../loyalty-constants';

export const useLoyaltyRewardDetailsPath = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(MediaQuery.Mobile);
  const { inRestaurantLoyaltyEnabledAtRestaurant } = useInRestaurantRedemptionContext();
  const { getStoreStatusFlags } = useStoreContext();

  const isLoyaltyRewardDetailsPathEnabled = useCallback(
    (store?: StoreProxy, serviceMode?: ServiceMode | null): boolean => {
      const isLoyaltyEnabledInRestaurant = isMobile && inRestaurantLoyaltyEnabledAtRestaurant;
      let isStoreEnabled = true;
      if (store) {
        const { isStoreOpenAndAvailable } = getStoreStatusFlags(store as IStore, serviceMode);
        isStoreEnabled = isStoreOpenAndAvailable;
      }
      return isLoyaltyEnabledInRestaurant && isStoreEnabled;
    },
    [getStoreStatusFlags, isMobile, inRestaurantLoyaltyEnabledAtRestaurant]
  );

  const makeLoyaltyRewardDetailsPath = useCallback<(rewardId: string, search?: string) => string>(
    (rewardId, search = '') => {
      const rewardIdPath = rewardId.length ? `/${rewardId}` : '';
      return `${formatMessage({ id: 'routes.loyaltyHome' })}/${LIST}${rewardIdPath}${search}`;
    },
    [formatMessage]
  );

  return {
    isLoyaltyRewardDetailsPathEnabled,
    makeLoyaltyRewardDetailsPath,
  };
};
